import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../redux/hooks';
import { useTheme } from '../themeContext';

// -- Redux 

// -- Components 

import Notification from '../components/general/notification/Notification';
import Container from '../components/camera/Container';
import Page from '../components/general/containers/Page';

const Camera: React.FC = () => {

  const dispatch = useAppDispatch(); 

  const colors = useAppSelector(state => state.theme.colors);

  const { isLightMode, toggleTheme } = useTheme();

  const navigate = useNavigate();
  const { t } = useTranslation();

  // -- 

  return (
    
    <Page>

        <Container />

    </Page>
  );
};

export default Camera;